import { render, staticRenderFns } from "./WorkflowBuilder.vue?vue&type=template&id=660cfdb4&scoped=true"
import script from "./WorkflowBuilder.vue?vue&type=script&lang=js"
export * from "./WorkflowBuilder.vue?vue&type=script&lang=js"
import style0 from "./WorkflowBuilder.vue?vue&type=style&index=0&id=660cfdb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660cfdb4",
  null
  
)

export default component.exports